
import { defineComponent, computed, ref } from "vue";

import ApiService from "@/core/services/ApiService";

export default defineComponent({
  name: "card-1",
  components: {},
  props: {
    progress: Number,

    statusDataBadgeColor: String,

    statusDataColor: String,

    status: String,

    icon: String,

    title: String,

    dba_alias: String,

    description: String,

    chargebacks: String,

    budget: String,

    apis: Array,

    href: String,

    id: String,

    totalSales: Number,

    totalChargebacks: Number,

    cbratio: String,
  },
  setup(props) {
    const getDescription = computed(() => {
      return props.description
        ? `${props.description}`
        : "Merchant Number: 99999999";
    });

    const getChargebacks = computed(() => {
      return props.chargebacks ? props.chargebacks : "141";
    });

    const getBudget = computed(() => {
      return props.budget ? props.budget : "$2,900.00";
    });

    const getStatus = computed(() => {
      if (accountStatus.value === "-1") {
        return props.status === "1" ? "On" : "Off";
      }

      return accountStatus.value === "1" ? "On" : "Off";
    });

    const getStatusDataBadgeColor = computed(() => {
      return getStatus.value === "On"
        ? "badge-light-primary"
        : "badge-light-danger";
    });

    const getStatusDataColor = computed(() => {
      return props.statusDataColor ? props.statusDataColor : "bg-primary";
    });

    const accountStatus = ref("-1");
    const onClickStatus = async () => {
      let status = "0";
      if (getStatus.value === "Off") {
        status = "1";
      }

      const { data } = await ApiService.put(
        `merchants/accounts/${props.id}?onoff=${status}`,
        {}
      );
      if (data.success) {
        accountStatus.value = status;
      }
    };

    return {
      getDescription,
      getChargebacks,
      getBudget,
      getStatus,
      getStatusDataBadgeColor,
      getStatusDataColor,
      onClickStatus,
    };
  },
});
